// extracted by mini-css-extract-plugin
export default {"customBtn":"CustomButton_customBtn__J-8Ip"};